import { Injectable } from '@angular/core';
import { CanActivateChild, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class PasswordChangeGuard implements CanActivateChild {
    constructor(private router: Router) {}

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const mustChange = localStorage.getItem('must_change_pwd') === 'true';
        
        if (!mustChange) {
            return true;
        }

        // Allow access only to change-password page
        if (state.url.includes('/settings/change-password')) {
            return true;
        }

        // Block all other routes — force redirect to change password
        this.router.navigate(['/settings/change-password'], { replaceUrl: true });
        return false;
    }
}
